import type { Component } from '@builder.io/sdk';

export const RichTextFields = {};

const richTextBuilderConfig = {
  name: 'HCI Text Content',
  inputs: [
    {
      name: 'content',
      type: 'richText',
      defaultValue: '<p>Here is your Copy. Click on me to edit content!</p>',
    },
  ],
} satisfies Component;

export default richTextBuilderConfig;
